import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/fonts.css';
import './styles/reset.css';
import './styles/tokens.css';
import './styles/globals.css';
import { App } from '@/app/App';
import { rootStore } from '@/stores/RootStore';

if (import.meta.env.DEV) {
  (window as Window & { __skvoz?: unknown }).__skvoz = rootStore;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
